<template>
  <div id="app" @touchmove="TouchMove($event)">

    <transition :enter-active-class="EnterActiveClass"
                :leave-active-class="LeaveActiveClass">
      <router-view class="animated" style="position: absolute;top:0px;left:0px;animation-duration: 0.3s;-webkit-animation-duration: 0.3s;"/>
    </transition>

<!--    <ArticleList class="animated"-->
<!--                 style="position: absolute;left:0px;top:0px;">-->
<!--    </ArticleList>-->
<!--    <transition enter-active-class="slideInRight"-->
<!--                leave-active-class="slideOutRight">-->
<!--        <Article v-if="showArticle"-->
<!--                 style="position: absolute;left:0px;top:0px;animation-duration: 0.3s;-webkit-animation-duration: 0.3s;">-->
<!--        </Article>-->
<!--    </transition>-->
  </div>
</template>

<script>
  import ArticleList from "./components/1st/ArticleList";
  import Article from "./components/1st/Article";
  import store from './store/1st'
export default {
  name: 'App',
  store,
  components: {
    ArticleList,
    Article
  },
  mounted() {
    document.getElementById('app').addEventListener('touchmove', function (e) {e.preventDefault();}, false);
  },
  methods:{
    TouchMove:function (e) {
      e.preventDefault();
    }
  },
  computed:{
    EnterActiveClass(){
      if(this.$route.name=='ArticleList'){
        return 'slideInLeft';
      }else{
        return "slideInRight";
      }
    },
    LeaveActiveClass(){
      if(this.$route.name=='ArticleList'){
        return "slideOutRight";
      }else{
        return 'slideOutLeft';
      }
    },
    showArticle(){
      if(this.$route.name=='Article'){
        return true;
      }else{
        return false;
      }
    },
  }
}
</script>

<style>
  body{
    font-family:"微软雅黑";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding:0;
    margin:0;
    border:0;
    overflow: hidden;

    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
    -moz-text-size-adjust: 100% !important;
  }
  div{
    display: block;
    float: left;
  }

  /*文章内页统一样式*/
  .ArticleNormal{
    letter-spacing:0rem;
    text-indent: 7.4rem;
    text-align: justify;
    font-size: 3.7rem;
    color: #666666;
    line-height: 7rem;
  }
  .ArticleHead{
    /*text-indent: 7.4rem;*/
    text-align: justify;
    font-size: 4.8rem;
    color: #000000;
    font-weight: bolder;
    line-height: 10rem;
  }
  .ArticleBolder{
    font-weight: bolder;
    color: #000000;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue